import React from 'react';
import {OrbitComponent} from "../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {DenmarkSecondaryResponsibleGamingButtonBox} from "./denmark.secondary-responsible-gaming-button.box";
import {CyClass} from "../../../../../../../common/cy-classes";

export const DenmarkSecondaryResponsibleGamingButtonComponent = observer(class DenmarkSafeToPlayButtonComponent extends OrbitComponent {
    private _clickHandler = async () => {
        await this.services.linksNavigation.openSecondaryResponsibleGaming();
    }
    render() {
        return (
            <DenmarkSecondaryResponsibleGamingButtonBox imageUrl={this.services.theme.currentTheme.images.regulationSpecific.denmark.responsibleGamingButton.toString()}
                                        onClick={this._clickHandler}
                                        className={CyClass('cy-dk-secondary-rg-icon')}
            />
        );
    }
});